export const WALLETS_LIST = "WALLETS_LIST";
export const WALLETS_OWNER_TYPE_LIST = "WALLETS_OWNER_TYPE_LIST";


